import React from 'react'
import {connect} from 'react-redux'
import {selectModal, hideModal} from '../../../redux/modules/modal'
import asModal from './AsModal'
import {toJS} from '../../../util/ToJS'
import asyncComponent from '../async-component/AsyncComponent'
import VisibleScoreScreen from '../../../domains/grandmaster/containers/VisibleScoreScreen'

const AsyncLogin = asyncComponent({
  loader: () => import('./login-and-register/LoginForm'),
  modules: ['./login-and-register/LoginForm'],
  webpack: () => [require.resolveWeak('./login-and-register/LoginForm')]
})

const AsyncRegister = asyncComponent({
  loader: () => import('./login-and-register/RegisterForm'),
  modules: ['./login-and-register/RegisterForm'],
  webpack: () => [require.resolveWeak('./login-and-register/RegisterForm')]
})

const AsyncForgotPassword = asyncComponent({
  loader: () => import('./forgot-password/ForgotPasswordForm'),
  modules: ['./forgot-password/ForgotPasswordForm'],
  webpack: () => [require.resolveWeak('./forgot-password/ForgotPasswordForm')]
})

const AsyncCrewMember = asyncComponent({
  loader: () => import('../../../domains/about-us/components/CrewMemberModal'),
  modules: ['../../../domains/about-us/components/CrewMemberModal'],
  webpack: () => [require.resolveWeak('../../../domains/about-us/components/CrewMemberModal')]
})

const AsyncErrorTagEditor = asyncComponent({
  loader: () => import('../../../domains/dashboard_v3/components/ErrorTagEditor'),
  modules: ['../../../domains/dashboard_v3/components/ErrorTagEditor'],
  webpack: () => [require.resolveWeak('../../../domains/dashboard_v3/components/ErrorTagEditor')]
})

const AsyncJobEditor = asyncComponent({
  loader: () => import('../../../domains/about-us/components/JobEditor'),
  modules: ['../../../domains/about-us/components/JobEditor'],
  webpack: () => [require.resolveWeak('../../../domains/about-us/components/JobEditor')]
})

const AsyncSurveyModal = asyncComponent({
  loader: () => import('../../../domains/topic/components/SurveyModal'),
  modules: ['../../../domains/topic/components/SurveyModal'],
  webpack: () => [require.resolveWeak('../../../domains/topic/components/SurveyModal')]
})

const AsyncShareContent = asyncComponent({
  loader: () => import('./share-content/ShareContent'),
  modules: ['./share-content/ShareContent'],
  webpack: () => [require.resolveWeak('./share-content/ShareContent')]
})

const AsyncEditProblemTopicTagsModal = asyncComponent({
  loader: () => import('../../../domains/topic/components/EditProblemTopicTagsModal'),
  modules: ['../../../domains/topic/components/EditProblemTopicTagsModal'],
  webpack: () => [require.resolveWeak('../../../domains/topic/components/EditProblemTopicTagsModal')]
})

const AsyncReportContent = asyncComponent({
  loader: () => import('./report-content/ReportContent'),
  modules: ['./report-content/ReportContent'],
  webpack: () => [require.resolveWeak('./report-content/ReportContent')]
})

const AsyncContentEditorIframe = asyncComponent({
  loader: () => import('./content-editor-iframe/ContentEditorIframe'),
  modules: ['./content-editor-iframe/ContentEditorIframe'],
  webpack: () => [require.resolveWeak('./content-editor-iframe/ContentEditorIframe')]
})

const MODAL_COMPONENTS = {
  'LOGIN': AsyncLogin,
  'REGISTER': AsyncRegister,
  'FORGOT_PASSWORD': AsyncForgotPassword,
  'CONTENT_EDITOR': AsyncContentEditorIframe,
  'SHARE': AsyncShareContent,
  'REPORT': AsyncReportContent,
  'CREW_MEMBER': AsyncCrewMember,
  'ERROR_TAG_EDITOR': AsyncErrorTagEditor,
  'JOB_EDITOR': AsyncJobEditor,
  'SURVEY_MODAL': AsyncSurveyModal,
  'GM_SCORE_SCREEN': asModal(VisibleScoreScreen, 'Practice Results', true),
  'EDIT_PROBLEM_TOPIC_TAGS': AsyncEditProblemTopicTagsModal
  /* other modals */
}

class ModalRoot extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldTransition: true
    }
  }

  componentWillReceiveProps(nextProps) {
    const {modalType: currModalType} = this.props
    const {modalType: nextModalType} = nextProps

    if (currModalType !== null && nextModalType !== null) {
      this.setState({shouldTransition:false})
    } else {
      this.setState({shouldTransition:true})
    }
  }

  render() {
    const { modalType, modalProps, dispatch } = this.props
    if (!modalType) {
      return null
    }
    const {shouldTransition} = this.state

    const SpecificModal = MODAL_COMPONENTS[modalType]
    return <SpecificModal shouldTransition={shouldTransition} hideModal={()=>dispatch(hideModal())} {...modalProps} />
  }
}

export default connect(
  selectModal
)(toJS(ModalRoot))



// WEBPACK FOOTER //
// ./src/core/components/modals/ModalRoot.js